import axios from "axios";
export default {
  namespaced: true,

  state: {
    sos: []
  },

  getters: {
    sos(state) {
      return state.sos;
    },

    sosNumber(state) {
      if (state.sos && state.sos.length > 0) {
        return state.sos.length;
      } else {
        return state.sos.length;
      }
    }
  },

  mutations: {
    SET_SOS(state, sos) {
      state.sos = sos;
    }
  },

  actions: {
    async GetSOS({ commit }) {
      try {
        let response = await axios.get("/api/events/sos");
        commit("SET_SOS", response.data.data);
      } catch (e) {
        commit("SET_SOS", null);
      }
    },
    async sendSOS({ dispatch }, data) {
      try {
        await axios.post("/api/events/sos", data);
        return dispatch("GetSOS");
      } catch (e) {
        console.log("send error");
        this.$toast.open({
          message: "Error sending SOS",
          position: "top-right",
          type: "error"
        });
      }
    }
  }
};
